function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 452c8.284 0 15-6.716 15-15v-242c0-8.284-6.716-15-15-15s-15 6.716-15 15v242c0 8.284 6.716 15 15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m346 452c8.284 0 15-6.716 15-15v-242c0-8.284-6.716-15-15-15s-15 6.716-15 15v242c0 8.284 6.716 15 15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m166 452c8.284 0 15-6.716 15-15v-242c0-8.284-6.716-15-15-15s-15 6.716-15 15v242c0 8.284 6.716 15 15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46 150h45v347c0 8.284 6.716 15 15 15h300c8.284 0 15-6.716 15-15v-347h45c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-45c0-8.284-6.716-15-15-15h-105v-45c0-8.284-6.716-15-15-15h-120c-8.284 0-15 6.716-15 15v45h-105c-8.284 0-15 6.716-15 15v45h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15zm345 332h-270v-332h270zm-180-452h90v30h-90zm-120 60h330v30h-330z"
}));

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 20,
    viewBox: "0 0 512 512",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fec960ca.svg";
export { ForwardRef as ReactComponent };